module.exports = __webpack_public_path__ + "img/uz.85d4f493.svg";